<div class="hunt-details-package-item">
  <div class="title">
    <hyperkit-typography variant="body1">{{
      huntPackage?.title
    }}</hyperkit-typography>
  </div>
  <!-- <div class="tags">
        <hyperkit-tag
        [mode]="'fill'"
        [closable]="false"
        [textLeft]="'Hunt Queries'"
        [textRight]="'1/4'"
      ></hyperkit-tag>
      <hyperkit-badge
        [variant]="'success'"
        [size]="'large'"
        [indicator]="'icon'"
        [icon]="'check-circle'"
        [text]="'Complete'">
      </hyperkit-badge>
    </div> -->
</div>
